module.exports = __webpack_public_path__ + "static/media/header-mail.475a5031.svg";